module.exports = __webpack_public_path__ + "img/retrospect-63-mobile.29012387.jpg";